<td-wb-form #addressForm
            (submitAction)="reviewChanges()">
  <div class="td-wb-w8ben-form-update">
    <div class="td-wb-w8ben-form-update__content">
      @if (isPermanentResidenceStep) {
        <div class="td-wb-w8ben-form-update__residence__header"
             [attr.id]="getModalId()"
             translate="tdWb.w8BenForm.modal.update.permanentResidence.HEADER">
        </div>
        <div class="td-wb-w8ben-form-update__residence__sub-header"
             translate="tdWb.w8BenForm.modal.update.permanentResidence.SUB_HEADER">
        </div>
        <td-wb-radio-group name="permanentResidence"
                           [aria-label]="'tdWb.w8BenForm.modal.update.permanentResidence.SUB_HEADER' | translate"
                           [(ngModel)]="isPermanentResidence"
                           tdWbInput>
          <td-wb-selectable-input-panel class="td-wb-w8ben-form-update__residence__input-panel">
            <td-wb-radio class="td-wb-w8ben-form-update__residence__radio"
                         name="yesPermanentResidence"
                         selectorPosition="center"
                         [value]="true">
              <span id="td-wb-w8ben-form-update-residence-yes"
                    translate="tdWb.w8BenForm.modal.update.permanentResidence.YES">
              </span>
            </td-wb-radio>
            <td-wb-radio class="td-wb-w8ben-form-update__residence__radio"
                         name="noPermanentResidence"
                         selectorPosition="center"
                         [value]="false">
              <span id="td-wb-w8ben-form-update-residence-no"
                    translate="tdWb.w8BenForm.modal.update.permanentResidence.NO">
              </span>
            </td-wb-radio>
          </td-wb-selectable-input-panel>
        </td-wb-radio-group>
      } @else if (isUpdateProfileStep) {
        <div class="td-wb-w8ben-form-update__profile">
          <h2><span [attr.id]="getModalId()"
                    translate="tdWb.w8BenForm.modal.update.profileUpdate.TITLE"></span></h2>
          <td-wb-notification notificationType="info">
            <span translate="tdWb.w8BenForm.modal.update.profileUpdate.UPDATE_INFORMATION"></span>
          </td-wb-notification>
          <div class="td-wb-w8ben-form-update__profile-form">
            <div class="td-wb-w8ben-form-update__profile-details">
              <div class="td-wb-w8ben-form-update__profile-form__title">
                <span translate="tdWb.w8BenForm.modal.update.profileUpdate.PROFILE_DETAILS_LABEL"></span>
              </div>
              <td-wb-form-row>
                <td-wb-input-group class="td-wb-w8ben-form-update__profile-details__input">
                  <td-wb-input-group-label class="td-wb-w8ben-form-update__label">
                    <label for="td-wb-w8ben-form-update-input-legalName">
                      <span translate="tdWb.w8BenForm.modal.update.profileUpdate.LEGAL_NAME_LABEL"></span>
                    </label>
                  </td-wb-input-group-label>
                  <td-wb-input-group-field class="td-wb-w8ben-form-update__form-input-field">
                    <input id="td-wb-w8ben-form-update-input-legalName"
                           type="text"
                           class="td-wb-w8ben-form-update__form-input-field"
                           name="legalName"
                           tdWbInput
                           [(ngModel)]="profile.legalName"
                           [disabled]="true">
                  </td-wb-input-group-field>
                </td-wb-input-group>
                <td-wb-input-group class="td-wb-w8ben-form-update__profile-details__input">
                  <td-wb-input-group-label class="td-wb-w8ben-form-update__label">
                    <label for="td-wb-w8ben-form-update-input-dateBirth">
                      <span translate="tdWb.w8BenForm.modal.update.profileUpdate.DATE_BIRTH_LABEL"></span>
                    </label>
                  </td-wb-input-group-label>
                  <td-wb-input-group-field class="td-wb-w8ben-form-update__form-input-field">
                    <input id="td-wb-w8ben-form-update-input-dateBirth"
                           type="text"
                           class="td-wb-w8ben-form-update__form-input-field"
                           name="dateBirth"
                           tdWbInput
                           [(ngModel)]="profile.birthDt"
                           [disabled]="true">
                  </td-wb-input-group-field>
                </td-wb-input-group>
                <td-wb-input-group class="td-wb-w8ben-form-update__profile-details__input--small">
                  <td-wb-input-group-label class="td-wb-w8ben-form-update__label">
                    <label for="td-wb-w8ben-form-update-input-citizenship">
                      <span translate="tdWb.w8BenForm.modal.update.profileUpdate.CITIZENSHIP_LABEL"></span>
                    </label>
                  </td-wb-input-group-label>
                  <td-wb-input-group-field class="td-wb-w8ben-form-update__form-input-field">
                    <input id="td-wb-w8ben-form-update-input-citizenship"
                           type="text"
                           class="td-wb-w8ben-form-update__form-input-field"
                           name="citizenship"
                           tdWbInput
                           [(ngModel)]="profile.citizenship"
                           [disabled]="true">
                  </td-wb-input-group-field>
                </td-wb-input-group>
                <td-wb-input-group class="td-wb-w8ben-form-update__profile-details__input td-wb-w8ben-form-update__input--multi-lines">
                  <td-wb-input-group-label class="td-wb-w8ben-form-update__label">
                    <label for="td-wb-w8ben-form-update-sin">
                      <span translate="tdWb.w8BenForm.modal.update.profileUpdate.SIN_LABEL"></span>
                      <td-wb-w8ben-tooltip>
                        <span translate="tdWb.w8BenForm.modal.update.profileUpdate.SIN_TOOLTIP_DESCRIPTION"></span>
                      </td-wb-w8ben-tooltip>
                    </label>
                  </td-wb-input-group-label>
                  <td-wb-input-group-field class="td-wb-w8ben-form-update__form-input-field">
                    <input id="td-wb-w8ben-form-update-sin"
                           type="text"
                           class="td-wb-w8ben-form-update__form-input-field"
                           name="sin"
                           tdWbInput
                           [(ngModel)]="sin"
                           [disabled]="true">
                  </td-wb-input-group-field>
                </td-wb-input-group>
                <td-wb-input-group class="td-wb-w8ben-form-update__profile-details__input td-wb-w8ben-form-update__input--multi-lines">
                   <td-wb-input-group-label class="td-wb-w8ben-form-update__label">
                    <label for="td-wb-w8ben-form-update-ssn">
                      <span translate="tdWb.w8BenForm.modal.update.profileUpdate.SSN_LABEL"></span>
                      <td-wb-w8ben-tooltip>
                        <span translate="tdWb.w8BenForm.modal.update.profileUpdate.SSN_TOOLTIP_DESCRIPTION"></span>
                      </td-wb-w8ben-tooltip>
                    </label>
                  </td-wb-input-group-label>
                  <td-wb-input-group-field class="td-wb-w8ben-form-update__form-input-field">
                    <input id="td-wb-w8ben-form-update-ssn"
                           type="text"
                           class="td-wb-w8ben-form-update__form-input-field"
                           name="ssn"
                           minlength="9"
                           maxlength="9"
                           tdWbInput
                           [pattern]="allowableTinCharactersRegex"
                           [(ngModel)]="tin"
                           (click)="onClickTinInput()">
                     <td-wb-input-errors errorKeyNamespace="tdWb.w8BenForm.modal.update.profileUpdate.tinErrors"
                                         [errorKeyDisplayBeforeSubmit]="['pattern']" />
                  </td-wb-input-group-field>
                </td-wb-input-group>
              </td-wb-form-row>
            </div>

            <div>
              <div class="td-wb-w8ben-form-update__profile-form__title">
                <span translate="tdWb.w8BenForm.modal.update.profileUpdate.RESIDENCE_ADDRESS_LABEL"></span>
              </div>
              <td-wb-address #homeAddress
                             [showTitleAndCallout]="false" />
              <td-wb-checkbox id="td-wb-w8ben-form-update-show-mailing-address" [(ngModel)]="showMailingAddress">
                <span translate="tdWb.w8BenForm.modal.update.profileUpdate.MAILING_ADDRESS_CHECKBOX_LABEL"></span>
              </td-wb-checkbox>
            </div>

            @if (showMailingAddress) {
              <div>
                <div class="td-wb-w8ben-form-update__profile-form__title">
                  <span translate="tdWb.w8BenForm.modal.update.profileUpdate.MAILING_ADDRESS_LABEL"></span>
                </div>
                <td-wb-address #mailingAddress
                               usageId="mailing"
                               [showTitleAndCallout]="false" />
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="td-wb-w8ben-form-update__contact-us__title"
             translate="tdWb.w8BenForm.modal.update.contact.TITLE">
        </div>
        <div class="td-wb-w8ben-form-update__contact-us__description"
             translate="tdWb.w8BenForm.modal.update.contact.DESCRIPTION">
        </div>
        <td-wb-notification notificationType="info">
          <span [innerHTML]="'tdWb.w8BenForm.modal.update.contact.NOTIFICATION' | translate"></span>
        </td-wb-notification>
      }
    </div>

    <div class="td-wb-w8ben-form-update__actions">
      <td-wb-divider />
      <td-wb-page-action-panel position="end"
                               [top]="true"
                               [bottom]="false"
                               [left]="false"
                               [right]="false">
        <button id="td-wb-w8ben-form-update-residence-back"
                tdWbButton
                tdWbButtonType="secondary"
                (click)="onBackClick()">
          <span translate="tdWb.w8BenForm.modal.update.permanentResidence.BACK"></span>
        </button>
        @if (isPermanentResidenceStep || isUpdateProfileStep) {
          @if (isUpdateProfileStep) {
            <button id="td-wb-w8ben-form-update-residence-continue"
                    tdWbButton
                    tdWbButtonType="primary"
                    type="submit"
                    [disabled]="isPermanentResidence === null">
              <span translate="tdWb.w8BenForm.modal.update.permanentResidence.CONTINUE"></span>
            </button>
          } @else {
            <button id="td-wb-w8ben-form-update-residence-continue"
                    tdWbButton
                    tdWbButtonType="primary"
                    [disabled]="isPermanentResidence === null"
                    (click)="onContinueClick()">
              <span translate="tdWb.w8BenForm.modal.update.permanentResidence.CONTINUE"></span>
            </button>
          }
        } @else {
          <button id="td-wb-w8ben-form-update-contact-us-exit"
                  tdWbButton
                  tdWbButtonType="primary"
                  [tdWbModalClose]="modalCloseReason">
            <span translate="tdWb.w8BenForm.modal.update.contact.EXIT"></span>
          </button>
        }
      </td-wb-page-action-panel>
    </div>
  </div>
</td-wb-form>
